<div class="investment-amount-picker">
  @if (!investmentInfo?.enableShareBasedIncrement) {
    <div class="input-panel">
      <label class="input-label" for="investmentLot">{{ 'investment.lot' | translate }}</label>
      <div class="input-field">
        <input
          type="text"
          class="form-control"
          id="investmentLot"
          [value]="displayValue"
          [class.error]="errorKey"
          digitOnly
          [pattern]="IntegerPattern"
          (input)="onManualInput($event.target.value)"
        />
      </div>
      @if (errorKey === 'lessThanMin') {
        <div class="error tw-mt-1.5 tw-py-2 tw-pr-5 tw-text-xs tw-text-primary">
          {{ 'settings.lessThanMin' | translate: { min: displayMinimum } }}
        </div>
      }
      @if (errorKey === 'incrementFalse') {
        <div class="error tw-mt-1.5 tw-py-2 tw-pr-5 tw-text-xs tw-text-primary">
          {{ 'settings.incrementFalse' | translate: { min: unitStep } }}
        </div>
      }
    </div>

    <div class="investment-live-summary tw-bg-[#f8f9fa] tw-rounded-lg tw-p-6">
        <div class="tw-flex tw-justify-between tw-items-center">
          <h4 class="tw-font-semibold tw-text-black tw-m-0">
            {{ 'investment.yourInvestment' | translate }}
          </h4>
          <div class="tw-text-2xl tw-font-bold tw-text-primary" [attr.translate]="'no'">
            {{ 'investment.rm' | translate }} {{ displayAmount | number: '1.2-2' }}
          </div>
        </div>
        <div class="tw-text-sm tw-text-gray-500 tw-mt-1 tw-text-right">
          {{ sharesForDisplay | number }} {{ 'investment.shares' | translate }}
        </div>
      </div>
  } @else {
    <div class="tw-mb-6">

      <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-4 tw-mb-4">
        <h4 class="tw-font-medium tw-text-black tw-m-0">
          {{ (inputUnit === 'amount' ? 'investment.selectInvestmentAmount' : 'investment.selectShareAmount') | translate }}
        </h4>
        <div class="unit-toggle tw-flex tw-shrink-0 tw-items-center tw-justify-end tw-gap-[6px]">
          <span class="unit-toggle-label">{{ 'investment.enterAmountInLabel' | translate }}</span>
          <div class="unit-toggle-pill tw-flex tw-items-center tw-justify-center tw-gap-[6px] tw-w-[120px] tw-h-[32px] tw-bg-[#f8f8f8] tw-rounded-full">
            <span class="unit-toggle-label">{{ 'investment.share' | translate }}</span>
            <mat-slide-toggle
              class="secondary"
              [checked]="inputUnit === 'amount'"
              (change)="setInputUnit($event.checked ? 'amount' : 'share')"
            >
            </mat-slide-toggle>
            <span class="unit-toggle-label">{{ 'investment.rm' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="tw-grid tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-4 tw-mb-4">
        @for (tier of activeTiers; track $index) {
          <button
            type="button"
            class="tier-btn"
            [class.selected]="selectedTierIndex === $index && !isCustomAmount"
            (click)="selectTier($index)"
          >
            @if ($index === 0) {
              <div class="tier-tag">{{ 'investment.minimumTag' | translate }}</div>
            }
            @if (inputUnit === 'amount') {
              <div class="tw-text-gray-500 tw-text-sm">
                {{ 'investment.rm' | translate }}
              </div>
              <div class="tw-font-semibold tw-text-2xl tw-text-black">
                {{ tier | number: (inputUnit === 'amount' ? '1.2-2' : '1.0-0') }}
              </div>
            } @else {
              <div class="tw-font-semibold tw-text-2xl tw-text-black">
                {{ tier | number: (inputUnit === 'amount' ? '1.2-2' : '1.0-0') }}
              </div>
              <div class="tw-text-gray-500 tw-text-sm">
                {{ 'investment.shares'| translate }}
              </div>
            }
          </button>
        }
        <button type="button" class="tier-btn" [class.selected]="isCustomAmount" (click)="selectOtherAmount()">
          <div class="tw-font-semibold tw-text-2xl tw-text-black">{{ 'investment.other' | translate }}</div>
        </button>
      </div>

      @if (isCustomAmount) {
        <div class="tw-bg-[#f7f9fc] tw-rounded-2xl tw-p-8 tw-mb-6">
          <h4 class="tw-font-medium tw-text-black tw-mb-4 tw-text-center tw-text-xl">
            {{ (inputUnit === 'amount' ? 'investment.enterAmount' : 'investment.enterShareAmount') | translate }}
          </h4>
          <div class="amount-input-row tw-relative tw-flex tw-items-center tw-justify-center">
            <span class="tw-text-2xl tw-font-bold tw-text-gray-700 tw-mr-4">
              {{ (inputUnit === 'amount' ? 'investment.rm' : 'investment.share') | translate }}
            </span>
            <input
              type="text"
              id="investmentShareInput"
              [value]="customAmountInput"
              (input)="onAmountInput($event.target.value)"
              [placeholder]="inputUnit === 'amount' ? '0.00' : '0'"
              [class.error]="errorKey"
              digitOnly
              [decimal]="inputUnit === 'amount'"
              [pattern]="inputUnit === 'share' ? IntegerPattern : DoubleDecimalPattern"
              class="form-control tw-font-medium tw-text-2xl tw-h-[70px] tw-w-[30%] tw-text-center tw-bg-white tw-shadow-none tw-border-2 tw-border-[#e7e7e7] tw-rounded-xl tw-px-4 tw-py-2 tw-transition-colors"
            />
            <div class="amount-step-buttons">
              <button
                type="button"
                class="amount-step-btn"
                aria-label="Decrease"
                [disabled]="decrementDisabled"
                (click)="adjustCustomAmount(-1)"
              >
                -
              </button>
              <button
                type="button"
                class="amount-step-btn"
                aria-label="Increase"
                (click)="adjustCustomAmount(1)"
              >
                +
              </button>
            </div>
          </div>

          @if (errorKey === 'lessThanMin') {
            <p class="tw-mt-3 tw-text-sm tw-text-primary tw-text-center tw-font-medium">
              {{ 'settings.lessThanMinAmount' | translate: { min: (minimumInvestmentAmount | number: '1.2-2') } }}
            </p>
          }
          @if (errorKey === 'incrementFalse') {
            <p class="tw-mt-3 tw-text-sm tw-text-primary tw-text-center tw-font-medium">
              {{ 'settings.incrementFalseAmount' | translate:
                {
                  min: (incrementAmount | number: '1.2-2'),
                  incrementShares: investmentInfo.incrementShare
                }
              }}
            </p>
          }
          <p
            class="tw-mt-3 tw-text-sm tw-text-gray-500 tw-text-center"
            [innerHTML]="
              'investment.amountMultipleHint'
                | translate
                  : {
                      increment: (incrementAmount | number: '1.2-2'),
                      incrementShares: investmentInfo.incrementShare,
                      minimum: (minimumInvestmentAmount | number: '1.2-2'),
                    }
            "
          ></p>
        </div>
      }

      <div class="investment-live-summary tw-bg-[#f8f9fa] tw-rounded-lg tw-p-6">
        <div class="tw-flex tw-justify-between tw-items-center">
          <h4 class="tw-font-semibold tw-text-black tw-m-0">
            {{ 'investment.yourInvestment' | translate }}
          </h4>
          <div class="tw-text-2xl tw-font-bold tw-text-primary" [attr.translate]="'no'">
            {{ 'investment.rm' | translate }} {{ customAmount | number: '1.2-2' }}
          </div>
        </div>
        <div class="tw-text-sm tw-text-gray-500 tw-mt-1 tw-text-right">
          {{ sharesForDisplay | number }} {{ 'investment.shares' | translate }}
        </div>
      </div>
    </div>
  }
</div>
